import React from 'react';
import { PRIVACY_LABEL, PRIVACY_URL, TERMS_URL } from '../../config/aiDisclaimer';

// Registration checkbox consent copy with live Terms / Privacy links. Links
// inherit the label colour so they work on both light and dark forms.
const linkStyle: React.CSSProperties = { color: 'inherit', textDecoration: 'underline' };

export function TermsConsentText() {
  return (
    <>
      By clicking here, I agree to The Desire Company{' '}
      <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        Terms of Use
      </a>
      ,{' '}
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        {PRIVACY_LABEL}
      </a>
      , and use of any videos, photos, and commentary provided through this platform.
    </>
  );
}
